// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__49d-P","animation":"Loading_animation__Ise0g","title":"Loading_title__kOfYw"};